import { observer } from 'mobx-react-lite'
import { RestoreToWorkspaceDialog } from '@/features/user-management/RestoreToWorkspaceDialog'
import { type RestoreToWorkspaceDialogViewModel } from './RestoreToWorkspaceDialogViewModel'

export interface RestoreToWorkspaceDialogContainerProps {
  vm: RestoreToWorkspaceDialogViewModel
}

export const RestoreToWorkspaceDialogContainer = observer(
  function RestoreToWorkspaceDialogContainer({
    vm,
  }: RestoreToWorkspaceDialogContainerProps) {
    return (
      <RestoreToWorkspaceDialog
        showing={vm.modal.showing}
        onClose={vm.close}
        selectedUserName={vm.selectedUserName}
        selectedUserCount={vm.selectedUserIds.length}
        workspaceName={vm.workspace.name}
        onRestore={vm.restore}
        isRestorePending={vm.restore.pending}
      />
    )
  },
)
